module.exports = __webpack_public_path__ + "img/IMG_Phone_5.9f73743f.jpg";